/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortedHeader } from "components/Datatable/components/SortedHeader";
import { useFilterActions } from "@/pages/conciliation/balance-report/ducks/filter/hooks/actions";

export default function SortedCell({
  ...props
}: {
  title: string;
  column: any;
}) {
  const { updateFilter } = useFilterActions();
  const handleOrderChange = (value: { [key: string | number]: string }) => {
    updateFilter({ key: "order", value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  return <SortedHeader {...props} setOrder={handleOrderChange} />;
}
